export default "__VITE_ASSET__BP6siLJ3__"